import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Col, Row } from '_zari/core'

import * as PlantillaCobranzaService from 'services/plantillaCobranza.service'

import * as FormGroups from './formGroups'

const CrearEditarSection = ({ reloadTable, cancelOperation }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      cuentaContable: '',
      cuentaContableInfo: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    data => {
      PlantillaCobranzaService.nuevo(data)
        .then(() => {
          reloadTable()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext, reloadTable]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
      {({ errors, touched, handleSubmit, values, setFieldValue }) => (
        <Form>
          <FormGroups.CuentaContableFormGroup
            iError={errors.cuentaContable}
            iTouched={touched.cuentaContable}
            iValue={values.cuentaContableInfo}
            setFieldValue={setFieldValue}
          />
          <Row className='mt-2'>
            <Col md={12} className='text-right'>
              <Button color='secondary' onClick={cancelOperation}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(CrearEditarSection)
